module.exports = __webpack_public_path__ + "static/media/63.b8bdf46c.jpg";